/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/
import React from 'react';

import { Icon } from '@fitinsur/components';

import * as Styled from './styles';

import { GeneralSection } from '../index';

function renderSectionAddAndRemoveRowButtons({
  sectionState,
  setSectionState,
  index,
  questions,
  // questionnaireAnswersToDelete,
  // setQuestionnaireAnswersToDelete,
  onRemove = null,
  teamsGroupToDelete = [],
  setTeamsGroupToDelete
}) {
  return (
    <>
      {(index > 0 || sectionState.some((group)=> group.some(({ answer }) => answer))) && (
        <Styled.IconButton style={{ marginBottom: '15px' }} onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          const idPersonTeam = questions.find(({ idQuestion }) => idQuestion === 2182)?.idPerson;
          if (idPersonTeam) setTeamsGroupToDelete([...teamsGroupToDelete, idPersonTeam]);

          if (index == 0 && sectionState.length == 1) {
            const newRow = GeneralSection.events.createSectionRow({ questions, removeExtraDescriptionTop: true });

            setSectionState([newRow]);
          } else {
            const newArray = sectionState.filter((v, i) => i !== index);

            setSectionState(newArray);
          }

          if (onRemove) {
            onRemove({ idPersonTeam });
          }
        }}>
          <Icon name="trash" style={{ margin: 0 }} />
        </Styled.IconButton>
      )}

      {(index === sectionState.length - 1) && (
        <Styled.IconButton onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newArray = [...sectionState, GeneralSection.events.createSectionRow({ questions, removeExtraDescriptionTop: true })];

          setSectionState(newArray)
        }}>
          <Icon name="plus" style={{ margin: 0 }} />
        </Styled.IconButton>
      )}
    </>
  )
}

function renderDisplayOrder({
  index,
  groupLength,
  handleArrow,
  componentStyle = {}
}) {
  return (
    <div
      style={
        {
          ...componentStyle,
          width: "120px",
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: "0 20px 10px 0",
        }
      }
    >
      <Icon onClick={() => handleArrow("up", index)} name="sort-arrow-up" disabled={index === 0} />
      <span style={{ margin: '0 10px' }}>{index + 1}</span>
      <Icon onClick={() => handleArrow("down", index)} name="sort-arrow-down" disabled={index === groupLength - 1} />
    </div>
  );
};

const components = {
  Styled,
  renderSectionAddAndRemoveRowButtons,
  renderDisplayOrder
}

export { components }